import { Rgb, Track, locate } from "./tracks";
import { corners } from "./trackReport";

// What the debug overlay shows on a track, worked out apart from drawing it:
// a tick every 0.05 of the lap, each corner tinted by the best drift tier it
// has room for, and where a kart is in the lap's terms — the fraction and the
// lateral offset that `tracks.ts` takes (TRACK-IMPROVEMENTS.md, TOOL-4).

/** Ticks come this often, as a fraction of the lap. */
export const TICK_STEP = 0.05;

/** The samples the ticks stand at, from the start line on. */
export const tickSamples = (track: Track) => Array.from({ length: Math.round(1 / TICK_STEP) }, (_, k) => Math.floor(k * TICK_STEP * track.n));

/** Colours by drift tier: none, then 1 to 3. */
export const TIER_COLORS: Rgb[] = [[0.6, 0.6, 0.6], [0.35, 0.65, 1], [1, 0.82, 0.25], [1, 0.3, 0.25]];

/** Each corner with room for a drift: its first sample, how many samples, its tier. */
export const tierSpans = (track: Track) => corners(track).filter((c) => c.tier > 0).map((c) => ({ from: c.from, len: c.len, tier: c.tier }));

/**
 * Where a kart is in `tracks.ts`'s terms: the fraction of the lap (the middle
 * of its sample, so `floor(fraction * n)` lands back on it), and how far right
 * of the middle of the road.
 */
export function whereIs(track: Track, kart: { x: number; z: number; idx: number }) {
  return { frac: (kart.idx + 0.5) / track.n, lat: locate(track, kart.x, kart.z, kart.idx).lat };
}

/** The line for the debug readout, ready to paste: `[0.483, 2.1]`. */
export function whereText(track: Track, kart: { x: number; z: number; idx: number }) {
  const { frac, lat } = whereIs(track, kart);
  return `at ${frac.toFixed(3)} · lat ${lat >= 0 ? "+" : ""}${lat.toFixed(1)} · [${frac.toFixed(3)}, ${lat.toFixed(1)}]`;
}
